@import '@hevoio/hevo-ui-toolkit/styles/variables';
@import '@hevoio/hevo-ui-toolkit/styles/mixins';

.filterPellet {
  @include clear-btn-style();
  line-height: 12px;
  padding: $spacer * 0.25;
  border-radius: $border-radius-default;
  min-width: 30px;
  text-align: center;
  cursor: pointer;
  transition: all 200ms ease;
  font-weight: $font-weight-medium;
  font-size: $font-size-body;
  &:not(.activePellet) {
    &:hover, &:focus {
      font-weight: $font-weight-bold;
      background: $surface-bg;
      color: $text-default;
    }
  }
}

.filterPellet + .filterPellet {
  margin-left: $spacer * .25;
}

.activePellet {
  color: $light-text;
  background: $primary;
  font-weight: $font-weight-bold;
}

.filterBox {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
